import { render, staticRenderFns } from "./loginHeader2.vue?vue&type=template&id=d058de44&scoped=true&"
import script from "./loginHeader2.vue?vue&type=script&lang=js&"
export * from "./loginHeader2.vue?vue&type=script&lang=js&"
import style0 from "./loginHeader2.vue?vue&type=style&index=0&id=d058de44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d058de44",
  null
  
)

export default component.exports